import { Alert, Container, Spinner } from "@sembark-travel/ui-base"
import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { CreateWAFlowForm, useFetchIntegration } from "../../../../Integrations"
import { generatePath, useNavigate, useParams } from "../../../../router-utils"

export default function WhatsAppIntegrationFlowCreatePage() {
	const navigate = useNavigate()
	const { integrationId } = useParams(
		"/integrations/:integrationId/whatsapp/flows/new"
	)
	const {
		data: integration,
		error: integrationError,
		isValidating: integrationLoading,
	} = useFetchIntegration(integrationId)

	if (!integration?.integrated_app_id) {
		if (integrationLoading) {
			return <Spinner padding="8" alignCenter />
		}

		return (
			<Alert status="warning">
				{integrationError?.message ||
					"Unable to load the WhatsApp integration."}
			</Alert>
		)
	}

	const flowsPath = generatePath(
		"/integrations/:integrationId/whatsapp/flows",
		{ integrationId }
	)

	return (
		<>
			<Helmet>
				<title>New WhatsApp Flow</title>
			</Helmet>
			<Breadcrumbs
				title="New WhatsApp Flow"
				items={[
					[generatePath("/org/integrations"), "Integrations"],
					[flowsPath, integration.name],
					["", "New WhatsApp Flow"],
				]}
			/>
			<Container paddingY="6" bgColor="default">
				<CreateWAFlowForm
					integratedAppId={integration.integrated_app_id}
					onDone={() =>
						navigate("/integrations/:integrationId/whatsapp/flows", {
							params: { integrationId },
							replace: true,
						})
					}
				/>
			</Container>
		</>
	)
}
